// extracted by mini-css-extract-plugin
export default {"container":"shippings_container__jGDj2","list":"shippings_list__Tyu1m","shipping":"shippings_shipping__i42Rw","reset":"shippings_reset__I6KzR"};